<template>
  <el-dialog
    custom-class="login-page"
    width='900px'
    :title="dialogText"
    :visible.sync="dialogVisible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :before-close="stopPolling"
    :append-to-body="true"
    :lock-scroll="false">
    <el-form :model="formData" :rules='formDataRules' ref="formData" >
      <el-row type='flex' justify='center'>
        <el-col :span='12'>
          <img class="head-icon" :src="headIcon" alt="">
        </el-col>
      </el-row>
      <el-row type='flex' justify='center'>
        <el-col :span='12'>
          <el-form-item label="手机号" prop="mobile">
            <el-input id="input-tel"
              class="content-edit"
              v-model="formData.mobile"
              placeholder="请输入手机号"
              auto-complete="off"
              @keyup.enter.native="checkMobileLogin('formData')"
              @input="changeButtonColor">
            </el-input>
            <el-button class="button-yz" @click="getCode" type="text" :disabled="isDisabled">{{buttonName}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type='flex' justify='center'>
        <el-col :span='12'>
          <el-form-item label="验证码" prop="code">
            <el-input @input="changeButtonColor" @keyup.enter.native="checkMobileLogin('formData')" class="content-edit" v-model="formData.code" placeholder="请输入手机验证码" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="footer" style="padding-buttom: 100px">
      <span slot="footer" class="dialog-footer">
        <p class="prompt-title">根据国家法律要求，您需要完成手机认证</p>
        <el-button id="submit-button" type="primary" :disabled="buttonIsdisabled" @click="checkMobileLogin('formData')" :loading="isLoading">确定</el-button>
      </span>
    </div>
  </el-dialog>
</template>
<script>
import { checkMobileLogin, getVerifyCode } from '@/api/index'
import Validate from '@/utils/validate'

export default {
  inject: ['reload'],
  props: {
    dialogVisible: Boolean,
    headIcon: String
  },
  data () {
    // 校验电话号码
    var checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      }
      setTimeout(() => {
        if (Validate.isValid('mobile', value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号码'))
        }
      }, 500)
    }

    // 校验手机验证码
    var checkCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'))
      }
      setTimeout(() => {
        if (Validate.isValid('code', value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的验证码'))
        }
      }, 500)
    }
    return {
      dialogText: '验证手机号',
      // 内容数据字段
      formData: {
        mobile: null,
        code: null
      },
      buttonName: '获取验证码',
      // 按钮显示状态
      isDisabled: false,
      time: 89,
      // 校验规则
      formDataRules: {
        mobile: [
          { required: true, validator: checkMobile, trigger: 'blur' }
        ],
        code: [
          { required: true, validator: checkCode, trigger: 'blur' }
        ]
      },
      timeout: null,
      buttonIsdisabled: true,
      isLoading: false
    }
  },
  methods: {
    stopPolling () {
      this.$emit('closeDialog')
    },
    // 校验全部内容
    checkMobileLogin (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          // 整理form数据
          this.saveFormData()
          checkMobileLogin(this.formData)
            .then((res) => {
              this.isLoading = false
              if (res.code === 1) {
                window.location.href = `${window.location.origin}/${this.$route.params.id}`
              } else {
                this.$message.error(res.message)
              }
            })
            .catch((err) => {
              this.isLoading = false
              console.log(err)
            })
        } else {
        }
      })
    },
    // 获取手机验证码
    getCode () {
      this.$refs.formData.validateField('mobile', (err) => {
        if (!err) {
          this.isDisabled = true
          let interval = setInterval(function () {
            this.buttonName = this.time + '秒'
            --this.time
            if (this.time < 0) {
              this.buttonName = '重新发送'
              this.time = 89
              this.isDisabled = false
              clearInterval(interval)
            }
          }.bind(this), 1000)
          // 发送验证码
          var data = {
            mobile: this.formData.mobile
          }
          getVerifyCode(data)
            .then((res) => {
              if (res.code === 1) {
                this.feedBack('success', res.message)
              }
            })
            .catch((err) => {
              console.log(err)
            })
          this.isDisabled = true
        }
      })
    },
    saveFormData () {
      var wechatInfo = JSON.parse(localStorage.getItem('scholar_wechat_info'))
      this.$set(this.formData, 'wechat_info', wechatInfo)
    },
    changeButtonColor () {
      let formData = this.formData
      // 处理按钮置灰问题
      let flag = formData.mobile || formData.code
      if (flag) {
        this.buttonIsdisabled = true
      }
      let flag2 = formData.mobile && formData.code
      if (flag2) {
        this.buttonIsdisabled = false
      }
    }
  }
}
</script>
<style scoped lang="scss">
  @import './index.scss';
</style>
<style lang="scss">
.login-page {
  .el-form-item__error {
    left: 66px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CheckDialog/index.vue